import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
export default function AlbumCloude() {
  const $ = _c(14);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="summary">손쉽게 휴대폰 사진 PC로 옮기기</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <li><h4 className="order_title text_primary">방법 1. 매물 현장에선?</h4><p className="order_desc">집찍고 앱 카메라로 촬영 후 저장하면 끝!</p><Image className="img_guide" src="/image/desktop/popup/album01_01.png" alt={"\uB9E4\uBB3C \uD604\uC7A5\uC5D0\uC11C \uC9D1\uCC0D\uACE0 \uC571 \uCE74\uBA54\uB77C\uB85C \uCD2C\uC601 \uD6C4 \uC800\uC7A5\uD558\uBA74 \uB05D!"} width={100} height={100} /></li>;
    t2 = <li><h4 className="order_title text_primary">방법 2. 휴대폰 속 사진을 옮길 땐?</h4><p className="order_desc">올리기 메뉴에서 사진을 선택해서 업로드!</p><Image className="img_guide" src="/image/desktop/popup/album01_02.png" alt={"\uD734\uB300\uD3F0 \uC18D \uC0AC\uC9C4\uC744 \uC62E\uAE38 \uB550 \uC62C\uB9AC\uAE30 \uBA54\uB274\uC5D0\uC11C \uC0AC\uC9C4\uC744 \uC120\uD0DD\uD574\uC11C \uC5C5\uB85C\uB4DC!"} width={100} height={100} /></li>;
    t3 = <h4 className="order_title text_primary">방법 3. 방문이 힘들 땐?</h4>;
    t4 = <p className="order_desc">고객에게 사진요청 링크로 받으면 정리까지 한번에!</p>;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Image className="img_guide" src="/image/desktop/popup/album01_03.png" alt={"\uC911\uAC1C\uC0AC: \uACE0\uAC1D\uC5D0\uAC8C \uC0AC\uC9C4 \uC694\uCCAD, \uACE0\uAC1D: \uC911\uAC1C\uC0AC\uC5D0\uAC8C \uC0AC\uC9C4 \uBCF4\uB0B4\uAE30"} width={100} height={100} />;
    t6 = <Image className="img_guide" src="/image/desktop/popup/album01_04.png" alt={"\uC911\uAC1C\uC0AC: \uACE0\uAC1D \uC0AC\uC9C4 \uB3C4\uCC29"} width={100} height={100} />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  let t8;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <li>{t3}{t4}<div className="group_view">{t5}{t6}<a className="banner" href="https://www.aipartner.com/help/faq?seq=296" target="_blank" rel="noopener"><Image src="/image/desktop/popup/album01_banner01.png" alt={"\uB108\uBB34 \uBC14\uC05C \uC190\uB2D8! \uC9D1 \uBC29\uBB38\uC774 \uC5B4\uB835\uB2E4\uBA74\u200B \uC9D1\uCC0D\uACE0 \uB9C1\uD06C\uB85C \uC0AC\uC9C4\uC694\uCCAD\u200B. \uC790\uC138\uD788 \uBCF4\uAE30"} width={100} height={100} /></a></div></li>;
    t8 = <h4 className="order_title text_primary">올리기 꿀팁!</h4>;
    t9 = <p className="order_desc">폴더를 지정해서 올리면 따로 정리하지 않아도 사진 폴더 정리 끝!</p>;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t7 = $[7];
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  let t11;
  let t12;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Image className="img_guide" src="/image/desktop/popup/album01_05.png" alt={"1\uB2E8\uACC4: \uC6D0\uD558\uB294 \uD3F4\uB354\uB85C \uC704\uCE58 \uBCC0\uACBD, 2\uB2E8\uACC4: \uC6D0\uD558\uB294 \uD3F4\uB354 \uC120\uD0DD"} width={100} height={100} />;
    t11 = <Image className="img_guide" src="/image/desktop/popup/album01_06.png" alt={"3\uB2E8\uACC4: \uC6D0\uD558\uB294 \uD3F4\uB354\uC5D0 \uC800\uC7A5, 4\uB2E8\uACC4: \uBC18\uC601 \uD655\uC778 \uBC0F \uC0AC\uC9C4\uCCA9\uC5D0 \uC5C5\uB85C\uB4DC"} width={100} height={100} />;
    t12 = <Image className="img_guide" src="/image/desktop/popup/album01_07.png" alt={"5\uB2E8\uACC4: \uC6D0\uD558\uB294 \uD3F4\uB354 \uC815\uB9AC \uC644\uB8CC!"} width={100} height={100} />;
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
  } else {
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <>{t0}<ol className="list_order">{t1}{t2}{t7}<li>{t8}{t9}<div className="group_view">{t10}{t11}{t12}<a className="banner" href="https://www.aipartner.com/help/faq?seq=299" target="_blank" rel="noopener"><Image src="/image/desktop/popup/album01_banner02.png" alt={"\uAD11\uACE0 \uB9E4\uBB3C\uC0AC\uC9C4 \uCC3E\uC9C0\uB9D0\uACE0\u200B \uC9D1\uCC0D\uACE0\uAC00 \uC989\uC2DC \uCD94\uCC9C\u200B\u200B. \uC790\uC138\uD788 \uBCF4\uAE30"} width={100} height={100} /></a></div></li></ol></>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  return t13;
}